import { render, staticRenderFns } from "./AbstractsTable.vue?vue&type=template&id=492e345b&scoped=true"
import script from "./AbstractsTable.vue?vue&type=script&lang=js"
export * from "./AbstractsTable.vue?vue&type=script&lang=js"
import style0 from "./AbstractsTable.vue?vue&type=style&index=0&id=492e345b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e345b",
  null
  
)

export default component.exports